export default "__VITE_ASSET__IIGoXqrl__"